import lazyPage from "../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/pages/home/Reviews/Reviews.tsx",
    () => import("./Reviews"),
);
